import React, {useEffect, useRef, useState} from 'react'
import EditIcon from './icons/EditIcon'
import DeleteIcon from './icons/DeleteIcon'
import { Color, Colors } from '../styles/Colors'
import styled from 'styled-components'
import MoreIcon from './icons/MoreIcon'

const Wrapper = styled.div`
    position: relative; 
    max-width: 40px;
`;

const ActionBtn = styled.button`
    display: flex; 
    justify-content: center;
    align-items: center; 
    background: none; 
    border: none; 
    background-color: ${Color(Colors.blue)};  
    color: ${Color(Colors.white)}; 
    width: 40px; 
    height: 40px; 
    border-radius: 4px; 
    text-align: center; 
    cursor: pointer; 
    font-weight: 600; 
`;

const Buttons = styled.div`
    position: absolute; 
    top: 44px; 
    right: 0; 
    display: flex; 
    justify-content: center;
    align-items: center; 
    flex-direction: column; 
    background-color: ${Color(Colors.blue)};
    padding: 4px; 
    border-radius: 4px; 
    opacity: ${({$show})=> $show ? '1' : '0'}; 
    max-height: ${({$show})=> $show ? '80px' : '0'}; 
    box-shadow: ${({$show}) => $show ? '4px 4px 4px rgba(0, 0, 0, 0.3)' : '0'}; 
    pointer-events: ${({ $interactive }) => ($interactive ? 'auto' : 'none')};
    transition: opacity 100ms ease-out, max-height 100ms ease-out, box-shadow 100ms ease-out; 
    z-index: 1001; 
    
`;

const Button = styled.button`
    background: none; 
    border: none; 
    background-color: ${Color(Colors.blue)};  
    width: 32px; 
    height: 32px; 
    border-radius: 4px; 

    &:hover {
        background-color: ${Color(Colors.lightBlue)};
    }
`;

const DocActionMenu = ({ item, handleDeleteText, handleEditTextClick }) => {
    const [show, setShow] = useState(false);
    const [interactive, setInteractive] = useState(false); 
    const openTimeOut = useRef(null); 

    useEffect(() => {
        // Ensure buttons in module is clickable after the animation completes 
        if (show) {
            setInteractive(false)
            openTimeOut.current = setTimeout(() => setInteractive(true), 150); 
        } else {
            // Disable buttons in module when it's closing
            setInteractive(false)
            if (openTimeOut.current) {
                clearTimeout(openTimeOut.current); 
            }
        }
        return () => openTimeOut.current && clearTimeout(openTimeOut.current)
    }, [show])

    const safeClick = (fn) => (e) => {
        if (!interactive) return 
        fn(e);
        setShow(false)
    }


    return (
        <Wrapper>
            <ActionBtn onClick={() => setShow(!show)}>
                <MoreIcon />
            </ActionBtn>
            <Buttons 
                $show={show}
                $interactive={interactive}
            >
                <Button onClick={safeClick(() => handleEditTextClick(item))} style={{ margin: '0 0 0.5rem 0' }}>
                    <EditIcon
                        fill={Color(Colors.white)}
                        height='22px'
                        width='22px'
                    />
                </Button>
                <Button onClick={safeClick(() => handleDeleteText(item.id))}>
                    <DeleteIcon
                        fill={Color(Colors.white)}
                        height='22px'
                        width='22px'
                    />
                </Button>
            </Buttons>
        </Wrapper>
    )
}

export default DocActionMenu